
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pisteplattegrond-skikaart",
      function () {
        return require("private-next-pages/[region]/[resort]/pisteplattegrond-skikaart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pisteplattegrond-skikaart"])
      });
    }
  